import { RootState } from '../store';

export const selectTTDShelf = (state: RootState) => state.thingsToDoShelf;
